let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("lMH7t")).then(() => parcelRequire('8kufr'));